import styled, { css } from 'styled-components';
import { variant } from 'styled-system';
import { ThemeUtilities } from '../../../../../theme';
import { StepSize, StepState } from './types';

export const StepWrapper = styled.div<{
  color: StepState;
  size: StepSize;
  text: StepState;
  isActive: boolean;
  verticalSingleLine: boolean;
}>`
  display: flex;

  ${({ verticalSingleLine, theme }) =>
    verticalSingleLine
      ? css`
          flex-direction: row;
          column-gap: ${theme.space[3]}px;
          align-items: center;
        `
      : css`
          flex-direction: column;
        `};

  position: relative;
  transition: color 0.2s;
  will-change: color;

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'StepVertical', 'text'))};
  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'StepVertical', 'size'))};

  &:before {
    transition: background-color 0.2s;
    will-change: background-color;
    z-index: ${({ isActive }) => (isActive ? '1' : '0')};
    ${(props) =>
      variant(
        ThemeUtilities.getComponentVariant(props, 'StepVertical', 'color')
      )};
  }
`;

export const StepTextWrapper = styled.div`
  flex-shrink: 0;
`;
